const module = { name: 'swig', exports: {} }; const exports = module.exports;



import { Fandango as Fandango } from '@grins/fd-modules/splits/require-core';



import { swig_SwigClass as SwigClass } from '@grins/fd-modules/splits/require-core';



import { swig_customFilters as customFilters } from '@grins/fd-modules/splits/require-core';



const swig = SwigClass.newInstance()
customFilters.addFilters(swig.setFilter);
window.swig = swig;
function render(templateName, viewModel) {
    if (!templateName || typeof templateName !== 'string') {
        throw new Error(`${module.name} invalid/missing template name`);
    }
    const swigTemplate = Fandango.templates[templateName];
    if (typeof swigTemplate !== 'function') {
        throw new Error(`${module.name} template not found "${templateName}"`);
    }
    return swig.run(swigTemplate, viewModel);
}
module.exports = {
    render,
    setFilter: swig.setFilter,
};
export default module.exports;